module.exports = __webpack_public_path__ + "static/img/newcode.6cfa104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newcode.jpg
// module id = zSTh
// module chunks = 56